import { Controller } from "stimulus"
import { FetchRequest } from "@rails/request.js"

export default class extends Controller {
  static targets = ["sidebarNavigation"]

  siteHeader = document.getElementById('site-header');

  connect(){
    this.sidebarNavigationTarget.classList.contains("collapsed") ? this.siteHeader.classList.add('sidebar-collapsed') : this.siteHeader.classList.remove('sidebar-collapsed');
  }

  collapse() {
    this.updateCustomerSetting();

    this.sidebarNavigationTarget.classList.toggle("collapsed");

    this.sidebarNavigationTarget.classList.contains("collapsed") ? this.siteHeader.classList.add('sidebar-collapsed') : this.siteHeader.classList.remove('sidebar-collapsed');
  }

  async updateCustomerSetting() {
    const collapsed = this.sidebarNavigationTarget.classList.contains("collapsed");
    const sidebarFormat = collapsed ? "expanded" : "collapsed";

    const request = new FetchRequest("patch", "/customer", {
      body: {
        customer: {
          sidebar_format: sidebarFormat
        }
      },
      responseKind: "json"
    })

    await request.perform();
  }
}
